import { startOfMonth, startOfYear } from 'date-fns';
import { ObjectUpdate } from '../../../concepts/objects';
import { ColorGroup } from '../../../ui';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Frame } from './Frame';
import { ActivityFrameAddon } from './addons/ActivityFrameAddon';
import { CalendarFrameAddon } from './addons/CalendarFrameAddon';
import { GridFrameAddon } from './addons/GridFrameAddon';
import { TimelineFrameAddon } from './addons/TimelineFrameAddon';

class CreateFrameToolBehavior extends CreatePhysicalToolBehavior2(Frame, 'drag') {

    protected createSubject(u: ObjectUpdate): Frame {
        const frame = super.createSubject(u);
        frame.width = this.settings.width ?? 1600;
        frame.height = this.settings.height ?? 900;
        if (this.settings.background) {
            frame.background = this.settings.background;
        }
        if (this.settings.addon === 'activity') {
            const activity = u.create(ActivityFrameAddon);
            frame.title = 'Frame';
            frame.add(activity);
        }
        if (this.settings.addon === 'grid') {
            const grid = u.create(GridFrameAddon);
            grid.dimensions = this.settings.dimensions ?? [5, 5];
            grid.layoutMode = this.settings.layoutMode;
            frame.title = grid.dimensions.join('x');
            frame.add(grid);
        }
        else if (this.settings.addon === 'timeline') {
            const timeline = u.create(TimelineFrameAddon);
            timeline.color = ColorGroup.findPeer(this.settings.color ?? ColorGroup.default[0], 4);
            timeline.from = startOfYear(new Date());
            timeline.dimensions = [12, 1];
            timeline.layoutMode = this.settings.layoutMode;
            frame.title = 'Timeline';
            frame.add(timeline);
        }
        else if (this.settings.addon === 'calendar') {
            const calendar = u.create(CalendarFrameAddon);
            calendar.color = ColorGroup.findPeer(this.settings.color ?? ColorGroup.default[0], 4);
            calendar.from = startOfMonth(new Date());
            frame.title = 'Calendar';
            frame.add(calendar);
        }
        else {
            frame.title = 'Frame';
        }
        return frame;
    }

    protected shouldConsume() {
        return true;
    }
}

export const frameTool = defineToolWithCommonBehaviors({
    id: 'frameTool',
    label: 'Frames',
    category: 'design',
    icon: 'deqo://icons/d2/frame',
    weight: 3040,
    behaviors: [
        CreateFrameToolBehavior,
    ]
});

